import truncate from './modules/truncate';
import popup from './modules/popup';
import slider from './modules/slider';
import modal from './modules/modal';
import modalGallery from './modules/modal-gallery';
import mediaResourcesPlayVideoBtn from './modules/media-resources-play-video';
import accordion from './modules/accordion';
import mediaResourceSelect from './modules/media-resource-select';
import mobile_menu from './modules/mobile_menu';
import certified from './modules/certified';
import in_view from './modules/in-view';
import newsFilterCategoryDd from './modules/news-filter-category-dd';
import sticky from './modules/sticky';
import b7 from './modules/b7';
import contactForm from './modules/contact-form';
import quick_links from './modules/quick_links';
import map from './modules/map';
import partners from './modules/partners';
import timeline from './modules/timeline';
import caseFilter from './modules/case-filter';
import processFilter from './modules/process-filter';
import documentCentreFilter from './modules/document-centre-filter';
import tabs from './modules/tabs';
import searchAutoFocus from './modules/searchAutoFocus';
import fadeInUplogo from './modules/fadeInUp-logo';
import select2 from './modules/select2';
import gtm from './modules/gtm';
import searchFeaturedContent from './modules/search-featured-content.js';
import motions_filter from './modules/motions-filter';

[
  truncate, // Drupal Behavior

  popup,
  slider,
  modal,
  modalGallery,
  mediaResourcesPlayVideoBtn,
  accordion,
  mediaResourceSelect,
  mobile_menu,
  certified,
  in_view,
  newsFilterCategoryDd,
  sticky,
  b7,
  contactForm,
  quick_links,
  map,
  partners,
  timeline,
  caseFilter,
  processFilter,
  documentCentreFilter,
  tabs,
  searchAutoFocus,
  fadeInUplogo,
  select2,
  gtm,
  searchFeaturedContent,
  motions_filter
].forEach(
  module => { module(); }
);
